@if(detailsBuilderObject){<mat-card class="profile-card px-15 pb-20">



    <mat-card-header>
        <mat-card-title>
            <div class="header-title-row">
                <div class="g-just-flex gap-15">
                    <div class="round-icon-wrapper contrast">
                        <mat-icon>
                            {{detailsBuilderObject.resourceIcon}}

                        </mat-icon>
                    </div>
                    <span>

                        {{detailsBuilderObject.resourceName | titlecase}}

                    </span>
                </div>
                <button mat-icon-button type="button" class="dialog-close-button" (click)="onRequestClose()"
                    *ngIf="dialogRef">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </mat-card-title>

    </mat-card-header>
    <mat-card-content>
        <div class="my-10">
            <mat-divider>

            </mat-divider>
            <div class="my-20"></div>

            <div class="g-just-flex special-header-wrapper  my-20 mb-20 gap-18"
                style="justify-content: space-between; flex-wrap: wrap;">
                @if(detailsBuilderObject.specialHeader ){
                @let specialHeader = detailsBuilderObject.specialHeader;

                <app-special-header-v2 [resourceObject]="resourceData"
                    [specialHeader]="specialHeader"></app-special-header-v2>
                }
                <div class="action-button mb-15 gap-15">
                    @if(actionButtons?.length){
                    <div class="g-just-flex gap-10 flex-wrap">
                        @for(button of actionButtons; track button.key){
                        @if(canShowAction(button)){
                        <button mat-flat-button [color]="button.color || 'primary'" (click)="triggerAction(button)">
                            @if(button.icon){<mat-icon>{{button.icon}}</mat-icon>}
                            {{button.label || (button.key | titlecase)}}
                        </button>
                        }
                        }
                    </div>
                    }
                </div>
            </div>

            <div class="cards-wrapper">
                @for(group of detailsBuilderObject.groups; track $index;){
                <mat-card>

                    <mat-card-header>
                        <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">

                            <div class="header-words  ">
                                <div class="title-flex" class="g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">
                                    <mat-icon>{{group.groupIcon}}</mat-icon> <mat-card-title>
                                        {{group.groupName}}</mat-card-title>
                                </div>

                            </div>
                        </div>
                    </mat-card-header>

                    <mat-card-content>
                        <!-- <app-details-cardz [group]="group" [resources]="data"></app-details-cardz> -->
                        <div class="my-10 mt-20">
                            <div class="my-10"></div>
                            <div class="card-content-details">
                                <div class="fields-wrapper g-just-flex gap-22" style="align-items:flex-end;">
                                    <!-- {{refinedResourceData | json}} -->
                                    @for(field of group.groupKeys; track $index;){
                                    <!-- {{keyVsResourceType[resourceData?.resourceType || '']?.[field]}} -->
                                    <!--if  type of key is not backbonelement-->
                                    @if(!isBackboneField(field)){
                                    @let fieldi = field.split('.')?.[0] || "";
                                    @let field2 = field.substring(0, field.indexOf('[')) || "";
                                    @if((isBackboneField(fieldi) || isBackboneField(field2))&&
                                    !(refinedResourceData?.[field])){
                                    }@else{
                                    <div class="field-group" #fg>
                                        <div class="field-value">
                                            <!-- {{resourceData?.[field] | json}} -->
                                            <div #sc class="value-with-icon">
                                                @if(isResourceIdentifierField(field)){
                                                  <div class="pb-3 pt-3">
                                                      <span class="small-subtitle" style="background: var(--mat-sys-surface-variant); color: var(--mat-sys-on-surface-variant); padding: 2px 6px; border-radius: 4px; display: inline-block; margin-bottom: 4px;">
                                                          {{getResourceIdentifierValue(field) | referenceIdentifier | async}}
                                                      </span>
                                                  </div>
                                                } @else if(isIdentifierOnlyReference(field)){
                                                  <div class="pb-3 pt-3">
                                                      <span class="small-subtitle" style="background: var(--mat-sys-surface-variant); color: var(--mat-sys-on-surface-variant); padding: 2px 6px; border-radius: 4px; display: inline-block; margin-bottom: 4px;">
                                                          {{refinedResourceData?.[field] | referenceIdentifier | async}}
                                                      </span>
                                                  </div>
                                                } @else if(isIdentifierOnlyReferenceArray(field)){
                                                @for (item of refinedResourceData?.[field]?.split(", ") || []; track $index) {
                                                  <div class="pb-3 pt-3">
                                                      <span class="small-subtitle" style="background: var(--mat-sys-surface-variant); color: var(--mat-sys-on-surface-variant); padding: 2px 6px; border-radius: 4px; display: inline-block; margin-bottom: 4px;">
                                                          {{item | referenceIdentifier | async}}
                                                      </span>
                                                  </div>
                                                }
                                                } @else if(isReferenceField(field)){
                                                  <div style="display: flex; flex-direction: column;">
                                                      <div class="pt-3">
                                                          <span class="small-subtitle" style="background: var(--mat-sys-surface-variant); color: var(--mat-sys-on-surface-variant); padding: 2px 6px; border-radius: 4px; display: inline-block; margin-bottom: 4px;">
                                                              {{refinedResourceData?.[field] | referenceIdentifier | async}}
                                                          </span>
                                                      </div>
                                                      <div class="pb-3">
                                                          <span [appReferenceDisplay]="refinedResourceData?.[field]"
                                                              InstantfetchAndRepace="true" [keepReference]="false"></span>
                                                      </div>
                                                  </div>
                                                } @else if(isReferenceFiedArray(field)){
                                                @for (item of refinedResourceData?.[field]?.split(", ") || []; track
                                                $index) {
                                                  <div style="display: flex; flex-direction: column;">
                                                      <div class="pt-3">
                                                          <span class="small-subtitle" style="background: var(--mat-sys-surface-variant); color: var(--mat-sys-on-surface-variant); padding: 2px 6px; border-radius: 4px; display: inline-block; margin-bottom: 4px;">
                                                              {{item | referenceIdentifier | async}}
                                                          </span>
                                                      </div>
                                                      <div class="pb-3">
                                                          <span [appReferenceDisplay]="item" InstantfetchAndRepace="true"
                                                              [keepReference]="false"></span>
                                                      </div>
                                                  </div>
                                                }
                                                }@else {
                                                @if(refinedResourceData?.[field]){
                                                @for(eV of (refinedResourceData?.[field] |
                                                isoDateFormatter).split('$#$'); track
                                                $index; let first = $first){
                                                @if(first){
                                                <div class="top ">
                                                    {{eV | titlecase}}
                                                </div>
                                                }@else{
                                                <div class="bottom subtitle-text-color-2 small-subtitle">
                                                    {{eV }}
                                                </div>
                                                }
                                                }

                                                }@else{
                                                {{'' | na}}
                                                }
                                                }
                                            </div>
                                        </div>
                                        <div class="field-title">

                                            {{(isResourceIdentifierField(field) ? 'Resource Identifier' : (resourceKeyLabels[resourceData!.resourceType]?.[field]??field)) |
                                            titlecase | na}}
                                        </div>
                                    </div>
                                    }}

                                    }
                                </div>
                            </div>
                        </div>
                    </mat-card-content>


                </mat-card>
                }
            </div>
        </div>
    </mat-card-content>
</mat-card>}